var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.heading))]),_c('p',[_vm._v(_vm._s(_vm.message)+" ("),_c('b',[_vm._v(_vm._s(_vm.code))]),_vm._v(")")])])}
var staticRenderFns = []

export { render, staticRenderFns }